/**
 * THIS IS A CLONE OF full-layout.compoment
 * This file will gradually be modified into RFID -- listeners, services, subscribers need to be reworked into rfid category. 
 */
import * as moment from 'moment';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subscription, Subject } from 'rxjs';
import { ToasterService } from 'angular2-toaster';
import { DaysUntilDuePipe } from 'app/shared/pipes';

import {
  Bin,
  EOD,
  Job,
  Batch,
  Order,
  Product,
  Setting,
  Shipment,
  Task,
  YellowBag,
  Role
} from '../models';
import { TranslateService } from '../i18n';
import {
  AuthenticationService,
  BatchService,
  EODService,
  JobService,
  MQTTService,
  OrderService,
  PrinterService,
  ProductService,
  RoleService,
  ScannerService,
  SettingService,
  ShipmentService,
  TemplateService
} from '../services';

import {
  CREATE_BATCH,
  CREATE_EOD,
  CREATE_JOB,
  CREATE_JOB_LOCATION,
  CREATE_ORDER,
  CREATE_PRODUCT,
  CREATE_SHIPMENT,
  CREATE_SUBASSEMBLY,
  CREATE_YELLOWBAG,
  DELETE_BATCH,
  DELETE_EOD,
  DELETE_JOB,
  DELETE_ORDER,
  DELETE_PRODUCT,
  DELETE_SHIPMENT,
  DELETE_SUBASSEMBLY,
  DELETE_YELLOWBAG,
  UPDATE_BATCH,
  UPDATE_BIN,
  UPDATE_EOD,
  UPDATE_JOB,
  UPDATE_ORDER,
  UPDATE_PRODUCT,
  UPDATE_PRODUCTS,
  UPDATE_SHIPMENT,
  UPDATE_SUBASSEMBLY,
  UPDATE_YELLOWBAG
} from '../../ngrx/mqtt-topics';

import {
  BOXED,
  CANCELLED,
  CLOSED,
  EOD_COMPLETED,
  PRINTED,
  SEALED,
  SHIPPED,
  RUSH,
  SERVICE,
  SHIPMENTS,
  DELIVERYDATE,
  DUEDATE,
  DAYSUNTILDUE,
  PENDING_PRINTING,
  PREPRESS,
  NEW,
  OPEN,
  MARKETPLACEEMAILS
} from '../../ngrx/status-types';

import { OA, RFID, SHEETS } from '../../ngrx/category-types';

import {
  _CLEAR,
  CLEAR_TASKS,
  DATA_INIT,
  GET_BATCHES,
  GET_BINS,
  GET_EOD_HISTORY,
  GET_JOBS,
  GET_MID_ORDERS,
  GET_NEXT_BUSINESS_DAY,
  GET_ORDERS,
  GET_FILTERED_ORDERS,
  GET_PRODUCTS,
  GET_RTS_TOTALS,
  GET_SETTINGS,
  GET_SUBASSEMBLIES,
  GET_SHIPMENTS,
  GET_TEMPLATES,
  GET_TEMPLATE_PDFS,
  GET_USERS,
  SET_BATCH_DETAILS_VIEW,
  SET_BATCH_LIST_VIEW,
  SET_BINS_VIEW,
  SET_EOD_HISTORY_VIEW,
  SET_LOGIN_VIEW,
  SET_HOLD_LIST_VIEW,
  SET_JOB_LIST_VIEW,
  SET_JOB_DETAILS_VIEW,
  SET_MAIN_VIEW,
  SET_ORDER_LIST_VIEW,
  SET_ORDER_DETAILS_VIEW,
  SET_PRODUCT_DETAILS_VIEW,
  SET_PRODUCT_LIST_VIEW,
  SET_SETTING_LIST_VIEW,
  SET_SHIPMENT_DETAILS_VIEW,
  SET_SHIPMENT_LIST_VIEW,
  SET_TEMPLATE_LIST_VIEW,
  SET_TEMPLATE_EDIT_FORM,
  SET_TEMPLATE_OVERLAY_VIEW,
  SET_USER_LIST_VIEW,
  GET_YELLOWBAGS,
  GET_LAST_EOD_RAN_TODAY,
  SET_GHS_LIST,
  SET_COMMENT_ORDERS_MAP,
  SET_COMMENT_JOBS_MAP,
  SET_COMMENT_SHIPMENT_MAP,
  SET_STICKER_LIST,
  SET_JOB_SHIP_FLAG,
  GET_HOLDBINS,
  SET_HOLDBINS_VIEW,
  UPDATE_HOLDBIN,
  GET_JOB_LOCATIONS,
  GET_ROLES,
  GET_MARKETPLACE_ORDERS
} from '../../ngrx/actions';

@Component({
  selector   : 'app-dashboard',
  templateUrl: './rfid-layout.component.html',
  styleUrls   : ['./rfid-layout.component.scss'],
  providers: [ DaysUntilDuePipe ]
})
export class RFIDLayoutComponent implements OnInit, OnDestroy {
  unmappedProducts = 0;
  allowEod               : boolean;
  loggingOut             : boolean;
  userRole            : any;
  tasks                  : Task[];
  batchesInit            : boolean;
  batchList              : Observable<Batch[]>;
  binList                : Observable<Bin[]>;
  binsInit               : boolean;
  currentlyDueOrders     : Observable<any>;
  dueTodayJobs           : number;
  eodList                : Observable<EOD[]>;
  eodProcessing          : boolean;
  jobAmounts             : Observable<any[]>;
  jobsInit               : boolean;
  jobList                : Observable<Job[]>;
  jobLocationsList       : Observable<Job[]>;
  mailInnovationsOrders  : Observable<any>;
  mainView               : Observable<any>;
  networkConnected       : boolean = false;
  ordersInit             : boolean;
  orderList              : Observable<Order[]>;
  products               : number;
  productList            : Observable<Product[]>;
  productsInit           : boolean;
  progressPercent        : number = 0;
  query                  : any;
  queryList              : any[];
  queryListNoMatch       : boolean;
  dueTodayAmount         : number;
  lastEODRanToday        : Observable<boolean>;
  lateOrderAmount        : number;
  lateJobs               : number;
  readyToShipAmount      : number;
  rtsJobs                : number;
  user                   : string;
  RTSTotal               : Observable<any>;
  shippingConfig         : any;
  nextBusinessDay        : Observable<string>;
  nextBusinessDate       : string;
  addressInvalidOrders   : Observable<Order[]>;
  dueTodayOrders         : Observable<Order[]>;
  RTSOrders              : Observable<Order[]>;
  reprintOverdueOrders   : Observable<Order[]>;
  overdueOrders          : Observable<Order[]>;
  pendingPrintOrders     : Observable<Order[]>;
  prePressOrders         : Observable<Order[]>;
  shipmentsInit          : boolean;
  shipmentList           : Observable<Shipment[]>;
  subAssembliesInit      : boolean;
  systemSettingList      : Observable<Setting[]>;
  taskList               : Observable<Task[]>;
  userListView           : Observable<any>;
  yellowBagList          : Observable<YellowBag[]>;
  roleList               : Observable<Role[]>;
  initCheck              : Subject<any>;
  ordersAndProductsLoaded: Subject<any>;
  initSubscriptions      : Subscription[];
  prePressLength         : number;
  reprintNoOfPages       : false;
  toastPresent           : boolean = false;
  loading                : boolean;
  public disabled = false;
  public language: { lang: string, url: string };
  public status  : {isopen: boolean} = {isopen: false};

  constructor(
    private authService    : AuthenticationService,
    private batchService   : BatchService,
    private eodService     : EODService,
    private jobService     : JobService,
    private mqttService    : MQTTService,
    private orderService   : OrderService,
    private printerService : PrinterService,
    private productService : ProductService,
    private route          : ActivatedRoute,
    private router         : Router,
    private scannerService : ScannerService,
    private settingService : SettingService,
    private shipmentService: ShipmentService,
    private roleService    : RoleService,
    private store          : Store<any>,
    private templateService: TemplateService,
    private toasterService : ToasterService,
    private translate      : TranslateService,
    private daysUntilDue   : DaysUntilDuePipe
  ) {
    this.batchList             = this.batchService.getBatchList();
    this.binList               = this.shipmentService.getBinList();
    this.currentlyDueOrders    = this.orderService.getCurrentlyDueOrders();
    this.dueTodayOrders        = this.orderService.getDueTodayOrderList();
    this.eodList               = this.eodService.getEODHistoryList();
    // this.jobAmounts            = this.jobService.getJobAmounts();
    this.jobList               = this.jobService.getJobList();
    this.lastEODRanToday       = this.eodService.getLastEODRanToday();
    this.mailInnovationsOrders = this.orderService.getMailInnovationsOrders();
    this.mainView              = this.authService.getMainView();
    this.addressInvalidOrders  = this.orderService.getAddressInvalidOrderList();
    this.nextBusinessDay       = this.settingService.getNextBusinessDay();
    this.orderList             = this.orderService.getOrderList();
    this.overdueOrders         = this.orderService.getOverdueOrderList();
    this.productList           = this.productService.getProductList();
    this.reprintOverdueOrders  = this.orderService.getReprintOverdueOrderList();
    this.RTSOrders             = this.orderService.getRTSOrderList();
    this.pendingPrintOrders    = this.orderService.getPendingPrintOrderList();
    this.prePressOrders        = this.orderService.getPrePressOrderList();
    this.RTSTotal              = this.shipmentService.getRTSTotal();
    this.shipmentList          = this.shipmentService.getShipmentList();
    this.systemSettingList     = this.settingService.getSettingList();
    // this.taskList              = this.store.select('notifications', 'taskList');
    this.yellowBagList         = this.shipmentService.getYellowBagList();
    this.roleList              = this.roleService.getRoleList();
  }

  public toggled(open: boolean): void {
    console.log('Dropdown is now: ', open);
  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  public logout(): void {
    this.authService.logout();
  }

  ngOnInit(): void {
    this.loading = true;
    const today = moment().format('YYYY-MM-DD');
    const lastWeek = moment(today).subtract(7, 'days');
    const tomorrow = moment(today).add(1, 'days');
    const tomorrowFormatted = tomorrow.format('YYYY-MM-DD');
    const lastWeekFormatted = lastWeek.format('YYYY-MM-DD');

    this.store.dispatch({
      type   : SET_ORDER_LIST_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_ORDER_DETAILS_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_EOD_HISTORY_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_JOB_DETAILS_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_JOB_LIST_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_HOLD_LIST_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_BATCH_LIST_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_BATCH_DETAILS_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_PRODUCT_LIST_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_PRODUCT_DETAILS_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_SETTING_LIST_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_SHIPMENT_DETAILS_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_SHIPMENT_LIST_VIEW,
      payload: {
        loading          : true,
        yellowBagsLoading: true
      }
    });
    this.store.dispatch({
      type   : SET_BINS_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_LOGIN_VIEW,
      payload: {
        loading: false,
        message: ''
      }
    });
    this.store.dispatch({
      type   : SET_HOLDBINS_VIEW,
      payload: { loading: true }
    });

    this.mainView
      .subscribe((mainViewState: any) => {
        const { 
          dueTodayJobs,
          lateJobs,
          loggingOut,
          shippingConfig 
        } = mainViewState;

        this.dueTodayJobs = dueTodayJobs;
        this.lateJobs = lateJobs;
        this.loggingOut = loggingOut;
        this.shippingConfig = shippingConfig;
      });

    this.initCheck               = new Subject();
    this.ordersAndProductsLoaded = new Subject();

    this.store.dispatch({
      type   : SET_MAIN_VIEW,
      payload: {
        process       : RFID,
        shippingConfig: this.settingService.getShippingConfig(),
      }
    });

    const lang = localStorage.getItem('language') || 'EN';
    const url  = lang === 'ES' ? 'assets/img/flags/Mexico.png' : 'assets/img/flags/USA.png';

    this.setLang(lang, url);
    this.userRole = this.authService.getUserRole();
    // console.log("this.userRole : ", this.userRole)
    const user = this.authService.getCurrentUser();
    this.user = user.substring(0, user.indexOf('@'));

    this.initSubscriptions = [
      /* TODO: need to refactor to work with RFID */
      this.mqttService
        .batchListener
        .subscribe(({ payload }) => {
          const { type, id, category, body, diffList } = payload;

          switch (type) {
            case CREATE_BATCH: 
              console.log(type);
              console.log(payload);
              if (id && category === RFID) {
                if(body){          
                  const batch = body.data.batch;
                  if(batch.compKey) {
                    batch.lines = batch.compKey.includes('unicorn') ? 'single_line' : 'multi_line';
                    batch.coating = batch.compKey.includes('coated') ? 'coated' : 'uncoated';
                    
                    if(batch.compKey.includes('horizon') || batch.compKey.includes('laser')) {
                      batch.cutting = batch.compKey.includes('horizon') ? 'horizon' : 'laser';
                    }
                  }
                  batch.activity_history.sort((a,b)=> Number(b.timestamp) - Number(a.timestamp));
                  if(batch.activity_history[batch.activity_history.length - 1] && batch.activity_history[batch.activity_history.length - 1].activity === OPEN) {
                    batch.createdAt = batch.activity_history[batch.activity_history.length - 1].timestamp;
                  }
                  batch.updatedAt = batch.activity_history.length && batch.activity_history[0].timestamp;  
                  this.store.dispatch({
                    type   : CREATE_BATCH,
                    payload: { batch }
                  }); 
                  console.log(`MQTT: Batch ${batch.id} created!`);                        
                } else{
                  this.batchService
                    .getBatch(id)
                    .take(1)
                    .subscribe(
                      (value: any) => {
                        console.log(value);
                        const { statusCode } = value;

                        if (statusCode === 200) {
                          const { batch } = JSON.parse(value.body).data;

                          if (batch) {
                            if(batch.compKey) {
                              batch.lines = batch.compKey.includes('unicorn') ? 'single_line' : 'multi_line';
                              batch.coating = batch.compKey.includes('coated') ? 'coated' : 'uncoated';
                              
                              if(batch.compKey.includes('horizon') || batch.compKey.includes('laser')) {
                                batch.cutting = batch.compKey.includes('horizon') ? 'horizon' : 'laser';
                              }
                            }
                            batch.activity_history = batch.activity_history && batch.activity_history.sort((a,b)=> Number(b.timestamp) - Number(a.timestamp));
                            if(batch.activity_history[0] && batch.activity_history[0].activity === OPEN) {
                              batch.createdAt = batch.activity_history[0].timestamp;
                              batch.updatedAt = batch.activity_history[batch.activity_history.length - 1].timestamp;
                            }
                            this.store.dispatch({
                              type   : CREATE_BATCH,
                              payload: { batch }
                            });
                            console.log(`MQTT: Batch ${batch.id} created!`);
                          }
                        }
                      },
                      (error: Error) => console.log(error)
                    );
                }
              }
              break;
            case DELETE_BATCH: 
              console.log(type);
              console.log(payload);
              if (id && category === RFID) {
                if (this.router.url.match(new RegExp(`/dashboard/batches/\\w+/${id}`, 'i'))) {
                  this.store.dispatch({
                    type   : SET_BATCH_DETAILS_VIEW,
                    payload: { loading: true }
                  });

                  this.store.dispatch({
                    type   : DELETE_BATCH,
                    payload: { id }
                  });

                  this.router.navigate(['dashboard/batches/all']);

                  this.store.dispatch({
                    type   : SET_BATCH_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                } else {
                  this.store.dispatch({
                    type   : DELETE_BATCH,
                    payload: { id }
                  });
                }

                console.log(`MQTT: Batch ${id} deleted!`);
              }
              break;
            case UPDATE_BATCH: 
              console.log('UPDATE BATCH RESPONSE');
              console.log(payload);
              
              let batchStatus = null;

              if (diffList) {
                const [ status ] = diffList.filter(({ path, diff, newVal }) => {
                  return path && path === 'batchStatus' && diff && diff === 'updated' && newVal;
                });

                batchStatus = (status && status.newVal) || '';
              }
              if (id && category === RFID && batchStatus != null) {
                if (this.router.url.match(new RegExp(`/dashboard/batches/\\w+/${id}`, 'i'))) {
                  if (batchStatus === CLOSED || batchStatus === PRINTED) {
                    this.store.dispatch({
                      type   : DELETE_BATCH,
                      payload: { id: id }
                    });

                    this.router.navigate(['dashboard/batches/all']);
                  } else {
                    this.store.dispatch({
                      type   : UPDATE_BATCH,
                      payload: { id, diffList }
                    });
                  }

                  this.store.dispatch({
                    type   : SET_BATCH_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                } else {
                  if (batchStatus === CLOSED || batchStatus === PRINTED) {
                    this.store.dispatch({
                      type   : DELETE_BATCH,
                      payload: { id: id }
                    });
                  } else {
                    if (batchStatus === SEALED) {
                      this.store.dispatch({
                        type   : SET_BATCH_LIST_VIEW,
                        payload: { sendBatches: false }
                      });
                    }
                    this.store.dispatch({
                      type   : UPDATE_BATCH,
                      payload: { id, diffList }
                    });
                  }
                }
                console.log(`MQTT: Batch ${id} updated!`); 
                                         
              }
              break;
          }
        }),

      this.mqttService
        .binListener
        .subscribe(({ payload }) => {
          const { type, id, category, body } = payload;

          switch (type) {
            case UPDATE_BIN: 
              console.log('UPDATE BIN RESPONSE');
              console.log(payload);
              if (id && category === RFID && body) {
                const { diffList } = body;

                this.store.dispatch({
                  type: UPDATE_BIN,
                  payload: { id, diffList }
                });

                console.log(`MQTT: Bin ${id} updated!`);
              }
              break;
          }
        }),

      this.mqttService
        .eodListener
        .subscribe(({ payload }) => {
          const { type, id, category } = payload;

          switch (type) {
            case CREATE_EOD: 
              console.log(`CREATE EOD RESPONSE`);
              console.log(payload);
              if (id && category === RFID) {
                this.eodService
                  .getEOD(id)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { eod } = JSON.parse(value.body).data;

                        if (eod) {
                          this.store.dispatch({
                            type   : CREATE_EOD,
                            payload: { eod }
                          });

                          console.log(`MQTT: EOD ${id} created!`);
                        }
                      }
                    },
                    (error: Error) => console.log(error)
                  );
              }
              break;
            case DELETE_EOD: 
              console.log(`DELETE EOD RESPONSE`);
              console.log(payload);
              if (id && category === RFID) {
                this.store.dispatch({
                  type   : DELETE_EOD,
                  payload: { id }
                });

                console.log(`MQTT: EOD ${id} deleted!`);
              }
              break;
            case UPDATE_EOD: 
              console.log(`UPDATE EOD RESPONSE`);
              console.log(payload);
              if (id && category == RFID) {
                this.eodService
                  .getEOD(id)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { eod } = JSON.parse(value.body).data;

                        if (eod) {
                          this.store.dispatch({
                            type   : UPDATE_EOD,
                            payload: { eod }
                          });

                          console.log(`MQTT: EOD ${id} updated!`);
                        }
                      }
                    },
                    (error: Error) => console.log(error)
                  )
              }
          }
        }),

      /* TODO: need to refactor to work with RFID */
      this.mqttService
        .jobListener
        .subscribe(({ payload }) => {
          const { type, id, category, body, diffList } = payload;

          switch (type) {
            case CREATE_JOB: 
              console.log('CREATE JOB RESPONSE');
              console.log(payload);
              if (id && category === RFID) {
                if(body){
                  const job = body.data.job;
                  this.store.dispatch({
                    type   : CREATE_JOB,
                    payload: { job }
                  });
                  console.log(`MQTT: Job ${id} created!`);
                } else {
                  this.jobService
                    .getJob(id)
                    .take(1)
                    .subscribe(
                      (value: any) => {
                        console.log(value);
                        const { statusCode } = value;

                        if (statusCode === 200) {
                          const { job } = JSON.parse(value.body).data;

                          if (job) {
                            this.store.dispatch({
                              type   : CREATE_JOB,
                              payload: { job }
                            });

                            console.log(`MQTT: Job ${id} created!`);
                          }
                        }
                      },
                      (error: Error) => console.log(error)
                    );
                }
              }
              break;
            case DELETE_JOB: 
              console.log('DELETE JOB RESPONSE');
              console.log(payload);
              if (id && category === RFID) {
                if (this.router.url.match(new RegExp(`/dashboard/jobs/\\w+/${id}`, 'i'))) {
                  this.store.dispatch({
                    type   : SET_JOB_DETAILS_VIEW,
                    payload: { loading: true }
                  });

                  this.store.dispatch({
                    type   : DELETE_JOB,
                    payload: { id }
                  });

                  this.router.navigate(['/rfid/dashboard/jobs/all']);

                  this.store.dispatch({
                    type   : SET_JOB_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                } else {
                  this.store.dispatch({
                    type   : DELETE_JOB,
                    payload: { id }
                  });
                }

                console.log(`MQTT: Job ${id} deleted!`);
              }
              break;
            case UPDATE_JOB: 
            if (id && category === RFID) {
                console.log('UPDATE JOB RESPONSE');
                console.log(payload);

                let jobStatus = null;

                if (diffList) {
                  const [ status ] = diffList.filter(({ path, diff, newVal }) => {
                    return path && path === 'jobStatus' && diff && diff === 'updated' && newVal;
                  });

                  jobStatus = (status && status.newVal) || '';
                }

                if (jobStatus && (jobStatus === EOD_COMPLETED || jobStatus === CANCELLED)) {
                  this.store.dispatch({
                    type   : DELETE_JOB,
                    payload: { id }
                  });
                  if (this.router.url.match(new RegExp(`/dashboard/jobs/\\w+/${id}`, 'i'))) {
                    this.router.navigate(['dashboard/jobs/all']);
                  } 
                  console.log(`MQTT: Job ${id} deleted!`); 
                } else {
                  if(diffList){
                    this.store.dispatch({
                      type   : UPDATE_JOB,
                      payload: { id, diffList }
                    });
                    console.log(`MQTT: Job ${id} updated!`);
                  }
                }

                // if (this.router.url.match(new RegExp(`/dashboard/jobs/\\w+/${id}`, 'i'))) {
                  this.store.dispatch({
                    type   : SET_JOB_DETAILS_VIEW,
                    payload: { artworkDownloading: false, loading: false }
                  }); 
                // }
              }
              break;
          }
        }),

      /* TODO: need to refactor to work with RFID */
      this.mqttService
        .orderListener
        .subscribe(({ payload }) => {
          const { type, id, category } = payload;

          switch (type) {
            case CREATE_ORDER: 
              console.log('CREATE ORDER RESPONSE');
              console.log(payload);
              if (id && category === RFID) {
                this.orderService
                  .getOrder(id)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { order } = JSON.parse(value.body).data;

                        if (order) {
                          this.store.dispatch({
                            type   : CREATE_ORDER,
                            payload: { order }
                          });

                          console.log(`MQTT: Order ${id} created!`);
                        }
                      }
                    },
                    (error: Error) => console.log(error)
                  );
              }
              break;
            case DELETE_ORDER: 
              console.log('DELETE ORDER RESPONSE');
              console.log(payload);
              if (id && category === RFID) {
                if (this.router.url.match(new RegExp(`/dashboard/orders/\\w+/${id}`, 'i'))) {
                  this.store.dispatch({
                    type   : SET_ORDER_DETAILS_VIEW,
                    payload: { loading: true }
                  });

                  this.store.dispatch({
                    type   : DELETE_ORDER,
                    payload: { id }
                  });

                    
                  this.router.navigate(['rfid/dashboard/orders/all']);

                  this.store.dispatch({
                    type   : SET_ORDER_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                } else {
                  this.store.dispatch({
                    type   : DELETE_ORDER,
                    payload: { id }
                  });
                }

                console.log(`MQTT: Order ${id} deleted!`);
              }
              break;
            case UPDATE_ORDER: 
              console.log('UPDATE ORDER RESPONSE');
              console.log(payload);
              if (id && category === RFID) {
                Observable
                  .combineLatest(
                    this.orderService.getOrder(id),
                    this.orderList,
                    this.jobList,
                    this.shipmentList
                  )
                  .take(1)
                  .subscribe(
                    ([ value, orders, jobList, shipments ]) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { order } = JSON.parse(value.body).data;
                        console.log("UPDATED ORDER", order)
                        if (order) {
                          if (this.router.url.match(new RegExp(`/dashboard/orders/\\w+/${id}`, 'i'))) {                            
                            if (order.status === EOD_COMPLETED || order.status === CANCELLED) {
                              this.store.dispatch({
                                type   : DELETE_ORDER,
                                payload: { id: order.id }
                              });

                              this.router.navigate(['rfid/dashboard/orders/all']);
  
                              if (order.status === CANCELLED && orders.find(o => o.id === order.id)) {
                                this.toasterService.clear();
                                this.toasterService.pop({
                                  type   : 'success',
                                  title  : this.translate.instant('ORDER_CANCELLED_HEADER'),
                                  body   : this.translate.instant('ORDER_CANCELLED_INFO', [order.id]),
                                  timeout: 8000
                                });

                                console.log(`MQTT: Order ${id} cancelled!`);
                              }
                            } else {
                              this.store.dispatch({
                                type   : UPDATE_ORDER,
                                payload: { order }
                              });

                              console.log(`MQTT: Order ${id} updated!`);
                            }

                            this.store.dispatch({
                              type   : SET_ORDER_DETAILS_VIEW,
                              payload: { loading: false }
                            });
                          } else {
                            if (order.status === EOD_COMPLETED || order.status === CANCELLED) {
                              this.store.dispatch({
                                type   : DELETE_ORDER,
                                payload: { id: order.id }
                              });
  
                              if (order.status === CANCELLED) {
                                this.toasterService.clear();
                                this.toasterService.pop({
                                  type   : 'success',
                                  title  : this.translate.instant('ORDER_CANCELLED_HEADER'),
                                  body   : this.translate.instant('ORDER_CANCELLED_INFO', [order.id]),
                                  timeout: 8000
                                });

                                console.log(`MQTT: Order ${id} cancelled!`);
                              }
                            } else {
                              this.store.dispatch({
                                type   : UPDATE_ORDER,
                                payload: { order }
                              });

                              console.log(`MQTT: Order ${id} updated!`);
                            }
                          }
                          // console.log(`order`);
                          // console.log(order);

                          if (order.status !== EOD_COMPLETED || order.status !== CANCELLED) {
                            let allJobsReady = true;
                            // console.log('alljobsReady : ',allJobsReady)
                            order.jobs.length && order.jobs.forEach(jobs => {
                              let job = jobList.find(o => o.id === jobs);
                              // console.log('jobId : ' + jobs + ' | job = ', job)
                              // console.log('jobStatus = ', job.status);
                              if(job && job.status !== SHIPMENTS) {
                                allJobsReady = false;
                              }
                            })
                            console.log(`all jobs ready in shipment: ${allJobsReady}`);

                            if (allJobsReady  ) {
                              // print packing slip for the shipment here
                              const orderShipment = shipments.find(shipment => shipment.orderId === order.id);
                              // console.log(`All jobs for order ${order.id} are ready!`);

                              if (orderShipment && (order.activity_history[0].activity === SHIPMENTS  && orderShipment.bin !== null && 
                                orderShipment.activity_history[0].activity !== 'qa Ok' && order.activity_history[0].user === user)) {
                                // fix this
                                const body = `
                                  <div>${this.translate.instant('NEW_SHIPMENT_CREATED_INFO6')} 
                                    #<strong>${orderShipment.orderId}</strong> ${this.translate.instant('NEW_SHIPMENT_CREATED_INFO9')} 
                                    <div class='bin-number'> 
                                    Bin #<strong>${orderShipment.bin}</strong>
                                    </div> ${this.translate.instant('NEW_SHIPMENT_CREATED_INFO8')}.
                                  </div>
                                `;
              
                                this.shipmentService.displayShipmentDetails.next({
                                  class: 'bg-success',
                                  title: this.translate.instant('NEW_SHIPMENT_FINISHED'),
                                  body
                                });
                              }

                            }
                          }
                          // this.toasterService.pop({
                          //   type: 'info',
                          //   title: this.translate.instant('ORDER_UPDATED'),
                          //   body: this.translate.instant('ORDER_UPDATED_INFO', [id]),
                          //   timeout: 8000
                          // });
                        }
                      }
                    },
                    (error: Error) => console.log(error)
                  );
              }
              break;
          }
        }),

      this.mqttService
        .productListener
        .subscribe(({ payload }) => {
          const { type, sku, skus, body, diffList } = payload;

          switch (type) {
            case CREATE_PRODUCT: 
              if (sku) {
                console.log('CREATE PRODUCT RESPONSE');
                console.log(payload);
                if(body){
                  const product = body;
                  this.store.dispatch({
                    type   : CREATE_PRODUCT,
                    payload: { product }
                  }); 
                  console.log(`MQTT: (gzip) Product ${product.sku} created!`);
                } else{
                  this.productService
                    .getProduct(sku)
                    .take(1)
                    .subscribe(
                      (value: any) => {
                        console.log(value);
                        const { statusCode } = value;

                        if (statusCode === 200) {
                          const { product } = JSON.parse(value.body).data;

                          if (product) {
                            this.store.dispatch({
                              type   : CREATE_PRODUCT,
                              payload: { product }
                            });

                            console.log(`MQTT: Product ${sku} created!`);
                          }
                        }
                      },
                      (error: Error) => console.log(error)
                    );
                }
              }
              break;
            case DELETE_PRODUCT: 
              if (sku) {
                console.log('DELETE PRODUCT RESPONSE');
                console.log(payload);
                this.store.dispatch({
                  type   : DELETE_PRODUCT,
                  payload: { sku }
                });

                console.log(`MQTT: Product ${sku} deleted!`);
              }
              break;
            case UPDATE_PRODUCT: 
              if (sku) {
                console.log('UPDATE PRODUCT RESPONSE');
                console.log(payload);
                if(diffList){
                  this.store.dispatch({
                    type   : UPDATE_PRODUCT,
                    payload: { sku, diffList }
                  });
                }                
              }
              break;
            case UPDATE_PRODUCTS: 
              if (skus) {
                console.log('UPDATE PRODUCTS RESPONSE');
                console.log(payload);
                this.productService
                  .getProductsBySKU(skus)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { productsBySKU } = JSON.parse(value.body).data;

                        if (productsBySKU) {
                          this.store.dispatch({
                            type   : UPDATE_PRODUCTS,
                            payload: { products: productsBySKU }
                          });

                          let productUpdatesMsg = `${this.translate.instant('PRODUCTS_UPDATED_INFO')}<br /><br />`;

                          productsBySKU.forEach(product => productUpdatesMsg += `${product.productName}<br />`);

                          console.log(`MQTT: Products ${skus} updated!`);
                        }
                      }
                    },
                    (error: Error) => console.log(error)
                  )
              }
              break;
          }
        }),

      /* TODO: need to refactor to work with RFID */
      this.mqttService
        .shipmentListener
        .subscribe(({ payload }) => {
          const { type, id, category, body } = payload;
          this.store.dispatch({
            type   : SET_SHIPMENT_DETAILS_VIEW,
            payload: {
              loading: true
            }
          });
          switch (type) {
            case CREATE_SHIPMENT: 
              console.log('CREATE SHIPMENT RESPONSE');
              console.log(payload);
              if (id && category === RFID && body) {
                const { shipment } = body;

                this.store.dispatch({
                  type: CREATE_SHIPMENT,
                  payload: { shipment }
                });

                this.store.dispatch({
                  type   : SET_JOB_SHIP_FLAG,
                  payload: { shipFlag: false }
                });

                const user = this.authService.getCurrentUser();

                if (shipment && shipment.createdBy === user ) {
                  let body,title = '';
                  if(shipment.jobs.length > 1) {
                    body = `
                      <div>
                        ${this.translate.instant('NEW_SHIPMENT_CREATED_INFO3')} 
                        <strong>${shipment.orderId}</strong>.
                        ${this.translate.instant('NEW_SHIPMENT_CREATED_INFO2')} 
                        <div class='bin-number'>
                        Bin #<strong>${shipment.bin}</strong>
                        </div>
                      </div>
                    `;
                    title = this.translate.instant('NEW_SHIPMENT_CREATED')
                    this.shipmentService.displayShipmentDetails.next({
                      class: 'bg-success',
                      title,
                      body
                    });
                  } 
                  // else {
                  //   body = `
                  //     <div>${this.translate.instant('NEW_SHIPMENT_CREATED_INFO6')}  
                  //       #<strong>${shipment.orderId}</strong> ${this.translate.instant('NEW_SHIPMENT_CREATED_INFO9')}
                  //       <div class='bin-number'>
                  //       Bin #<strong>${shipment.bin}</strong>
                  //       </div> ${this.translate.instant('NEW_SHIPMENT_CREATED_INFO8')}.
                  //     </div>
                  //   `;
                  //   title = this.translate.instant('NEW_SHIPMENT_FINISHED')
                  // }
                  // this.shipmentService.displayShipmentDetails.next({
                  //   class: 'bg-success',
                  //   title,
                  //   body
                  // });
                } 
                // else if(shipment && shipment.createdBy === user && shipment.jobs.length === 1 {
                //   const orderShipment = shipments.find(shipment => shipment.orderId === order.id);
                //   console.log(`All jobs for order ${order.id} are ready!`);
                //   if (orderShipment && (order.activity_history[0].activity=== SHIPMENTS && order.activity_history[0].user === user)) {
                //     const body = `
                //        <div>${this.translate.instant('NEW_SHIPMENT_CREATED_INFO6')} #<strong>${orderShipment.bin}</strong> ${this.translate.instant('NEW_SHIPMENT_CREATED_INFO7')} <strong>${orderShipment.orderId}</strong> ${this.translate.instant('NEW_SHIPMENT_CREATED_INFO8')}.</div>
                //     `;
  
                //     this.shipmentService.displayShipmentDetails.next({
                //       class: 'bg-success',
                //       title: this.translate.instant('NEW_SHIPMENT_FINISHED'),
                //       body
                //     });
                //   }
                // }

                console.log(`MQTT: Shipment ${shipment.id} created!`);
              }
              break;
            case DELETE_SHIPMENT: 
              console.log('DELETE SHIPMENT RESPONSE');
              console.log(payload);
              if (id && category === RFID) {  
                if (this.router.url.match(new RegExp(`/dashboard/shipping/\\w+/${id}`, 'i'))) {
                  this.store.dispatch({
                    type   : SET_SHIPMENT_DETAILS_VIEW,
                    payload: { loading: true }
                  });
                  
                  this.store.dispatch({
                    type   : DELETE_SHIPMENT,
                    payload: { id }
                  });

                  this.router.navigate(['dashboard/shipping/all']);

                  this.store.dispatch({
                    type   : SET_SHIPMENT_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                } else {
                  this.store.dispatch({
                    type   : DELETE_SHIPMENT,
                    payload: { id }
                  });
                }

                console.log(`MQTT: Shipment ${id} deleted!`);
              }
              break;
            case UPDATE_SHIPMENT: 
              if (id && category === RFID && body) {
                console.log('UPDATE SHIPMENT RESPONSE');
                console.log(payload);

                const { diffList, shippedBy, orderId, carrier } = body;

                let intlInvoice, packages, shipmentStatus, trackingNumber;

                diffList.forEach(entry => {
                  const { path, diff } = entry;

                  if (path && diff && diff === 'updated') {
                    if (path === 'intlInvoice') {
                      intlInvoice = entry;
                    } else if (path === 'packages') {
                      packages = entry;
                    } else if (path === 'shipmentStatus') {
                      shipmentStatus = entry;
                    } else if (path === 'trackingNumberUSPS' || path === 'trackingNumberUPS' || path ==='trackingNumberFEDEX') {
                      trackingNumber = entry;
                    }
                  }
                });

                const user = this.authService.getCurrentUser();
                
                if (this.router.url.match(new RegExp(`/dashboard/shipping/\\w+/${id}`, 'i'))) {
                  if (shipmentStatus && (shipmentStatus.newVal === EOD_COMPLETED || shipmentStatus.newVal === CANCELLED)) {
                    this.store.dispatch({
                      type: DELETE_SHIPMENT,
                      payload: { id }
                    });

                    this.router.navigate(['dashboard/shipping/all']);
                  } else {
                    // Print & Ship label printing trigger

                    if (trackingNumber && !trackingNumber.oldVal && trackingNumber.newVal && shippedBy === user) {
                      console.log(`Print & Ship label printing trigger`);
                      packages && packages.newVal.forEach(pkg => {
                        if (pkg.shippingLabel) {
                          // Address label uses a different printer
                          if(trackingNumber.newVal === 'USPS_SKIP_PROCESS') {
                            this.printerService.printAddressLabelZPL(pkg.shippingLabel, pkg.trackingNumber);
                          } else {
                            this.printerService.printZPL(pkg.shippingLabel, pkg.trackingNumber, carrier);
                          }
                        }
                      });
                      this.shipmentService.printInvoice.next({ printInv: true });
                    }

                    if (intlInvoice && !intlInvoice.oldVal && intlInvoice.newVal && shippedBy === user) {
                      console.log(`intl invoice print trigger`);
                      this.shipmentService.getShipment(id).subscribe(data => {
                        let shipment = JSON.parse(data.body).data.shipment;
                        if(shipment && (shipment.address.country_id == 'VI' || shipment.address.region == 'VI')) {
                          this.printerService.printIntlInvoice(intlInvoice.newVal, orderId);
                          this.shipmentService.openIntlInvoiceModal.next({ intlInvoice: intlInvoice.newVal, orderId });
                        }
                      });
                    }

                    if (shipmentStatus && shipmentStatus.oldVal === SHIPPED && shipmentStatus.newVal === BOXED) {
                      console.log(`shipment reverted trigger`);
                      if (!trackingNumber || !trackingNumber.oldVal) {
                        this.toasterService.pop({
                          type   : 'error',
                          title  : this.translate.instant('SHIPMENT_LABEL_ERROR'),
                          body   : this.translate.instant('SHIPMENT_LABEL_ERROR_INFO', [orderId]),
                          timeout: 8000
                        });
                      } else {
                        this.toasterService.pop({
                          type   : 'success',
                          title  : this.translate.instant('SHIPMENT_VOID_SUCCESS'),
                          body   : this.translate.instant('SHIPMENT_VOID_SUCCESS_INFO', [orderId]),
                          timeout: 8000
                        });
                      }
                    }

                    this.store.dispatch({
                      type: UPDATE_SHIPMENT,
                      payload: { id, diffList }
                    });
                  }

                  this.store.dispatch({
                    type   : SET_SHIPMENT_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                } else {
                  if (shipmentStatus === EOD_COMPLETED || shipmentStatus === CANCELLED) {
                    this.store.dispatch({
                      type: DELETE_SHIPMENT,
                      payload: { id }
                    });
                  } else {
                    this.store.dispatch({
                      type: UPDATE_SHIPMENT,
                      payload: { id, diffList }
                    });
                  }
                }
                
                console.log(`MQTT: Shipment ${id} updated!`);
              }
              break;
          }
          this.store.dispatch({
            type   : SET_SHIPMENT_DETAILS_VIEW,
            payload: {
              loading: false
            }
          });
        }),

      // this.mqttService
      //   .subAssemblyListener
      //   .subscribe(({ payload }) => {
      //     const { type, sku, skus } = payload;

      //     switch (type) {
      //       case CREATE_SUBASSEMBLY: 
      //         if (sku) {
      //           console.log('CREATE SUBASSEMBLY RESPONSE');
      //           console.log(payload);

      //           this.batchService
      //             .getProductSubAssembly(sku)
      //             .take(1)
      //             .subscribe(
      //               (value: any) => {
      //                 console.log(value);
      //                 const { statusCode } = value;

      //                 if (statusCode === 200) {
      //                   const { productSubAssembly } = JSON.parse(value.body).data;

      //                   if (productSubAssembly) {
      //                     this.store.dispatch({
      //                       type   : CREATE_SUBASSEMBLY,
      //                       payload: { productSubAssembly }
      //                     });

      //                     console.log(`MQTT: Subassembly ${sku} created!`);
      //                   }
      //                 }
      //               },
      //               (error: Error) => console.log(error)
      //             );
      //         }
      //         break;
      //       case DELETE_SUBASSEMBLY: 
      //         if (sku) {
      //           console.log('DELETE SUBASSEMBLY RESPONSE');
      //           console.log(payload);
      //           this.store.dispatch({
      //             type   : DELETE_SUBASSEMBLY,
      //             payload: { sku }
      //           });

      //           console.log(`MQTT: Subassembly ${sku} deleted!`);
      //         }
      //         break;
      //       case UPDATE_SUBASSEMBLY: 
      //         if (sku) {
      //           console.log('UPDATE SUBASSEMBLY RESPONSE');
      //           console.log(payload);

      //           this.batchService
      //             .getProductSubAssembly(sku)
      //             .take(1)
      //             .subscribe(
      //               (value: any) => {
      //                 console.log(value);
      //                 const { statusCode } = value;

      //                 if (statusCode === 200) {
      //                   const { productSubAssembly } = JSON.parse(value.body).data;

      //                   if (productSubAssembly) {
      //                     this.store.dispatch({
      //                       type   : UPDATE_SUBASSEMBLY,
      //                       payload: { productSubAssembly }
      //                     });

      //                     console.log(`MQTT: Subassembly ${sku} updated!`);
      //                   }
      //                 }
      //               },
      //               (error: Error) => console.log(error)
      //             );
      //         }
      //         break;
      //     }
      //   }),

      // this.mqttService
      // .jobLocationListener
      // .subscribe(({ payload }) => {
      //   const { type, body } = payload;

      //   switch (type) {
      //     case CREATE_JOB_LOCATION:
      //       console.log('CREATE JOB LOCATION RESPONSE');
      //       console.log(payload);
      //       if (body) {
      //         const jobLocation = body;
      //         this.store.dispatch({
      //           type: CREATE_JOB_LOCATION,
      //           payload: { jobLocation }
      //         });
      //         console.log(`MQTT: (gzip) jobLocation ${jobLocation.id} created!`);
      //       }
      //       break;
      //   }
      // }),
      
      this.initCheck
        .subscribe((init: any) => {
          const {
            batches,
            bins,
            jobs,
            orders,
            products,
            shipments,
            subAssemblies
          } = init;

          if (bins) this.binsInit                   = true;
          if (jobs) this.jobsInit                   = true;
          if (orders) this.ordersInit               = true;
          if (batches) this.batchesInit             = true;
          if (products) this.productsInit           = true;
          if (shipments) this.shipmentsInit         = true;
          if (subAssemblies) this.subAssembliesInit = true;

          // if (this.binsInit && this.jobsInit && this.ordersInit && this.batchesInit && this.shipmentsInit && this.subAssembliesInit && this.productsInit) {
          if (this.jobsInit && this.ordersInit) {
            this.mainView
              .take(1)
              .subscribe(({ dataInit }) => {
                if (!dataInit) {
                  this.store.dispatch({ type: DATA_INIT });
                  this.loading = dataInit;
                  this.store.dispatch({
                    type   : SET_BATCH_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_BATCH_LIST_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_BINS_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_EOD_HISTORY_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_HOLD_LIST_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_JOB_LIST_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_JOB_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_ORDER_LIST_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_ORDER_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_PRODUCT_LIST_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_PRODUCT_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_SHIPMENT_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_SHIPMENT_LIST_VIEW,
                    payload: {
                      loading          : false,
                      yellowBagsLoading: false
                    }
                  });
                  this.store.dispatch({
                    type   : SET_HOLDBINS_VIEW,
                    payload: { loading: false }
                  });
                }
              });
          }
        }),

      this.roleService
        .getAll()
        .subscribe(
          (value: any) => {
            console.log(value);
            const { errorMessage, statusCode } = value;

            if (statusCode === 400 || errorMessage) {
              this.store.dispatch({
                type: GET_ROLES,
                payload: { roles: [] }
              });
            } else {
              const { roles } = JSON.parse(value.body).data;

              console.log(`roles`);
              console.log(roles);

              this.store.dispatch({
                type: GET_ROLES,
                payload: { roles }
              });

              this.initCheck.next({ roles: true });
            }
          },
          (error: Error) => {
            console.log(error);

            this.store.dispatch({
              type: GET_ROLES,
              payload: { dies: [] }
            });

            this.initCheck.next({ dies: true });
          }
        ),
      /* TODO: need to refactor to work with RFID */
      this.eodService
        .getEODHistoryRange(
          RFID, 
          lastWeekFormatted, 
          tomorrowFormatted
        )
        .subscribe(
          (value: any) => {
            console.log(value);
            const { errorMessage, statusCode } = value;

            if (statusCode === 400 || errorMessage) {
              this.store.dispatch({
                type   : GET_EOD_HISTORY,
                payload: { eodHistory: [] }
              });
            } else {
              const { eodHistoryRange: eodHistory } = JSON.parse(value.body).data;
              console.log(`eod history`);
              console.log(eodHistory);

              this.store.dispatch({
                type   : GET_EOD_HISTORY,
                payload: { eodHistory }
              });
            }
          },
          (error: Error) => {
            console.log(error);
            this.store.dispatch({
              type   : GET_EOD_HISTORY,
              payload: { eodHistory: [] }
            });
          }
        ),

      /* TODO: need new query */
      this.orderService
        .getAll(RFID)
        .subscribe(
          (value: any) => {
            console.log(value);
            const { statusCode, errorMessage } = value;

            if (statusCode === 400 || errorMessage) {
              this.store.dispatch({
                type   : GET_JOBS,
                payload: { jobs: [] }
              });
              this.store.dispatch({
                type   : GET_ORDERS,
                payload: { orders: [] }
              });
              this.store.dispatch({
                type   : GET_PRODUCTS,
                payload: { products: [] }
              });
            } else {
              const { activeJobs: jobs, activeOrders: orders, products } = JSON.parse(value.body).data;
              console.log('jobs');
              console.log(jobs);
              console.log('orders');
              console.log(orders);
              // console.log(JSON.stringify(orders));

              console.log('products');
              console.log(products);

              this.store.dispatch({
                type   : GET_JOBS,
                payload: { jobs }
              });

              this.store.dispatch({
                type   : GET_ORDERS,
                payload: { orders }
              });
              this.store.dispatch({
                type   : GET_PRODUCTS,
                payload: { products }
              });

            }

            this.initCheck.next({ jobs: true, orders: true, products: true });
          },
          (error: Error) => {
            console.log(error);
            this.store.dispatch({
              type   : GET_JOBS,
              payload: { jobs: [] }
            });
            this.store.dispatch({
              type   : GET_ORDERS,
              payload: { orders: [] }
            });
            this.store.dispatch({
              type   : GET_PRODUCTS,
              payload: { products: [] }
            });

            this.initCheck.next({ jobs: true, orders: true, products: true });
          }
        ),

      /* TODO: need new query */
      this.batchService
        .getAllRFID()
        .subscribe(
          (value: any) => {
            console.log(value);
            const { statusCode, errorMessage } = value;

            if (statusCode === 400 || errorMessage) {
              this.store.dispatch({
                type   : GET_BATCHES,
                payload: { batches: [] }
              });
              this.store.dispatch({
                type   : GET_SUBASSEMBLIES,
                payload: { productSubAssemblies: [] }
              });
            } else {
              const { activeBatches: batches, productSubAssemblies } = JSON.parse(value.body).data;
              console.log('batches');
              console.log(batches);
              console.log('product sub assemblies');
              console.log(productSubAssemblies);
              batches.forEach(batch=>{
                if(batch.compKey) {
                  batch.lines = batch.compKey.includes('unicorn') ? 'single_line' : 'multi_line';
                  batch.coating = batch.compKey.includes('coated') ? 'coated' : 'uncoated';
                  
                  if(batch.compKey.includes('horizon') || batch.compKey.includes('laser')) {
                    batch.cutting = batch.compKey.includes('horizon') ? 'horizon' : 'laser';
                  }
                }
                batch.activity_history.sort((a,b)=> Number(b.timestamp) - Number(a.timestamp));
                if(batch.activity_history[batch.activity_history.length - 1] && batch.activity_history[batch.activity_history.length - 1].activity === OPEN) {
                  batch.createdAt = batch.activity_history[batch.activity_history.length - 1].timestamp;
                }
                batch.updatedAt = batch.activity_history.length && batch.activity_history[0].timestamp;
                
              })

              this.store.dispatch({
                type   : GET_BATCHES,
                payload: { batches }
              });
              this.store.dispatch({
                type   : GET_SUBASSEMBLIES,
                payload: { productSubAssemblies }
              });
            }

            this.initCheck.next({ batches: true, subAssemblies: true });
          },
          (error: Error) => {
            console.log(error);
            this.store.dispatch({
              type   : GET_BATCHES,
              payload: { batches: [] }
            });
            this.store.dispatch({
              type   : GET_SUBASSEMBLIES,
              payload: { productSubAssemblies: [] }
            });

            this.initCheck.next({ batches: true, subAssemblies: true });
          }
        ),

      /* TODO: need new query */
      this.shipmentService
        .getAllRFID()
        .subscribe(
          (value: any) => {
            console.log(value);
            const { statusCode, errorMessage } = value;

            if (statusCode === 400 || errorMessage) {
              this.store.dispatch({
                type   : GET_BINS,
                payload: { bins: [] }
              });
              this.store.dispatch({
                type   : GET_SHIPMENTS,
                payload: { shipments: [] }
              });

              this.store.dispatch({
                type   : SET_SHIPMENT_LIST_VIEW,
                payload: { error: this.translate.instant('SHIPMENTS_NOT_FOUND') }
              });
            } else {
              const { bins, activeShipments: shipments } = JSON.parse(value.body).data;

              console.log('bins');
              console.log(bins);
              console.log('shipments');
              console.log(shipments);

              this.store.dispatch({
                type   : GET_BINS,
                payload: { bins }
              });
              this.store.dispatch({
                type   : GET_SHIPMENTS,
                payload: { shipments }
              });

              this.store.dispatch({
                type   : SET_SHIPMENT_LIST_VIEW,
                payload: { error: '' }
              });
            }

            this.initCheck.next({ bins: true, shipments: true });
          },
          (error: Error) => {
            this.store.dispatch({
              type   : GET_BINS,
              payload: { bins: [] }
            });
            this.store.dispatch({
              type   : GET_SHIPMENTS,
              payload: { shipments: [] }
            });

            this.store.dispatch({
              type   : SET_SHIPMENT_LIST_VIEW,
              payload: { error: this.translate.instant('SHIPMENTS_NOT_FOUND') }
            });

            this.initCheck.next({ bins: true, shipments: true });
          }
        ),

      this.authService
        .getUsers()
        .subscribe(
          (value: any) => {
            console.log(value);
            const { errorMessage, statusCode } = value;

            if (statusCode === 400 || errorMessage) {
              this.store.dispatch({
                type   : GET_USERS,
                payload: { users: [] }
              });
            } else {
              const { users } = JSON.parse(value.body).data;
              console.log('users');
              console.log(users);

              this.store.dispatch({
                type   : GET_USERS,
                payload: { users }
              })
            }

            this.store.dispatch({
              type   : SET_USER_LIST_VIEW,
              payload: {
                loading           : false,
                userDetailsLoading: false
              }
            });
          },
          (error: Error) => {
            console.log(error);
            this.store.dispatch({
              type   : GET_USERS,
              payload: { users: [] }
            });
            this.store.dispatch({
              type   : SET_USER_LIST_VIEW,
              payload: {
                loading           : false,
                userDetailsLoading: false
              }
            });
          }
        ),

      this.settingService
        .getSettings()
        .subscribe(
          (value: any) => {
            console.log(value);
            const { statusCode, errorMessage } = value;

            if (statusCode === 400 || errorMessage) {
              this.store.dispatch({
                type   : GET_SETTINGS,
                payload: { settings: [] }
              });
            } else {
              const { settings } = JSON.parse(value.body).data;
              console.log('settings');
              console.log(settings);

              this.store.dispatch({
                type   : GET_SETTINGS,
                payload: { settings }
              });
            }

            this.store.dispatch({
              type   : SET_SETTING_LIST_VIEW,
              payload: { loading: false }
            });
          },
          (error: Error) => {
            console.log(error);
            this.store.dispatch({
              type: SET_SETTING_LIST_VIEW,
              payload: { loading: false }
            });
          }
        ),

      this.systemSettingList
        .subscribe(settings => {
          console.log("SETTINGS : ",settings)
          const nextBusinessDaySetting = settings && settings.find(setting => setting.name === 'SYSTEM.SETTING.NEXT_BUSINESS_DAY_RFID.NAME');
          const eodSetting = settings && settings.find(setting => setting.name === 'SYSTEM.SETTING.ENABLE_RFID_EOD.NAME');
          this.allowEod = eodSetting ? (eodSetting.value === 'true' ? true : false) : false;
          const nextBusinessDay = nextBusinessDaySetting && nextBusinessDaySetting.value;
          console.log(`next business day: ${nextBusinessDay}`);

          this.store.dispatch({
            type: GET_NEXT_BUSINESS_DAY,
            payload: { nextBusinessDay }
          });

          this.store.dispatch({
            type: SET_SETTING_LIST_VIEW,
            payload: { loading: false }
          });
        }),

      this.shipmentList
        .subscribe(shipments => {
          const RTS = [];
          let jobs = 0, packages = 0, rtsAll = 0;
          // "RTSTotal FIX"
          // console.log("nextBusinessDaySetting.value ",this.nextBusinessDate);
          shipments.forEach(shipment => {
            if (shipment.shipmentStatus === SHIPPED && (shipment.trackingNumberUPS || shipment.trackingNumberUSPS || shipment.trackingNumberFEDEX)) {
              // console.log("shipment dueDate: ",shipment.dueDate)
              rtsAll++;
              if(moment(shipment.dueDate, 'YYYY-MM-DD').isBefore(moment(this.nextBusinessDate, 'YYYY-MM-DD').add(1,'day'))) {
                RTS.push(shipment);
                jobs += shipment.jobs.length;
                packages += shipment.packages.length;
              }
            }
          });

          this.store.dispatch({
            type: GET_RTS_TOTALS,
            payload: { RTS, jobs, packages, rtsAll }
          });
        }),

      // Move to shipment list?
      this.shipmentList
        .subscribe(shipments => {
          const MIDShipments = [];
          let shipmentsCommentMap = {};
          shipments.forEach(shipment => {
            if (!shipment.yellowBagID && shipment.shipmentStatus === SHIPPED && shipment.serviceType === 'M4') {
              let weight = 0;

              shipment.packages.forEach(pkg => weight += pkg.weight);

              MIDShipments.push({
                id               : shipment.orderId,
                estimatedDelivery: shipment.expectedDate,
                jobs             : shipment.jobs,
                include          : true,
                weight
              });
            }
            if(shipment.activity_history) {
              const hasComment = this.commentOrder(shipment.activity_history);
              if(hasComment) {
                shipmentsCommentMap[shipment.id] = hasComment;
              }
            }
          });
          this.store.dispatch({
            type   : SET_COMMENT_SHIPMENT_MAP,
            payload: { shipmentsCommentMap }
          });
          this.store.dispatch({
            type   : GET_MID_ORDERS,
            payload: { MID_orders: MIDShipments }
          });
        }),

      // this.taskList
      //   .subscribe((taskList: Task[]) => this.tasks = taskList),

      this.eodList
        .subscribe(eodHistory => {
          const eodProcessing = eodHistory.some(eod => eod.processing === true);

          const lastEODRanToday = !!eodHistory.find(eod => {
            const ranToday = moment(eod.runDate, 'x').format('YYYY-MM-DD') === today;

            return ranToday && eod.lastOfDay;
          });

          console.log(`Last EOD ran today: ${lastEODRanToday}`);

          this.store.dispatch({
            type   : SET_MAIN_VIEW,
            payload: { eodProcessing }
          });

          this.store.dispatch({
            type: GET_LAST_EOD_RAN_TODAY,
            payload: { lastEODRanToday }
          });
        }),

      // this.productList
      //   .subscribe(products => {
      //     if (this.userRole) {
      //       this.unmappedProducts = 0;
      //       const totalProducts   = products.length;
      //       const taskCheck       = this.tasks.find(task => task.key === UNMAPPED_PRODUCTS);

      //       products.forEach(product => {
      //         if (!product.templateId) {
      //           this.unmappedProducts++;
      //         }
      //       });

      //       this.store.dispatch({
      //         type   : taskCheck ? EDIT_TASK: ADD_TASK,
      //         payload: {
      //           task: {
      //             key      : UNMAPPED_PRODUCTS,
      //             adminOnly: true,
      //             title    : 'UNMAPPED_PRODUCTS',
      //             message  : `${this.unmappedProducts}/${totalProducts}`,
      //             progress : `${((this.unmappedProducts / totalProducts) * 100).toFixed(0)}%`,
      //             link     : '/admin/products'
      //           }
      //         }
      //       });
      //     }
      //   }),

      this.mainView
        .subscribe(mainView => {
          const { 
            eodProcessing,
            networkConnected
          } = mainView;

          this.eodProcessing  = eodProcessing;
          this.networkConnected = networkConnected;
        }),
        
      this.jobList
        .subscribe(jobs=> {
          const jobsCommentMap = {};
          jobs.forEach(job=>{
            const hasComment = this.commentOrder(job.activity_history);
            if(hasComment) {
              jobsCommentMap[job.id] = true;
            }
          })
          this.store.dispatch({
            type   : SET_COMMENT_JOBS_MAP,
            payload: { jobsCommentMap }
          });
        }),

      this.scannerService
        .getJobLocationsLast24Hrs()
        .subscribe(
          (value: any) => {
            console.log(value);
            const { statusCode, errorMessage } = value;

            if (statusCode === 400 || errorMessage) {
              this.store.dispatch({
                type: GET_JOB_LOCATIONS,
                payload: { jobLocations: [] }
              });
            } else {
              const { getJobLocationsLast24Hrs } = JSON.parse(value.body).data;

              this.store.dispatch({
                type: GET_JOB_LOCATIONS,
                payload: { jobLocations: getJobLocationsLast24Hrs }
              });
            }
          },
          (error: Error) => {
            this.store.dispatch({
              type: GET_JOB_LOCATIONS,
              payload: { jobLocations: [] }
            });
          }
        ),

      Observable
        .combineLatest(
          this.lastEODRanToday,
          this.orderList, 
          this.shipmentList,
          this.nextBusinessDay
        )
        .subscribe(([ lastEODRanToday, orders, shipments, nextBusinessDay ]) => {
          // this.queryList = [ ...jobs, ...orders ];

          let lateJobs = 0, dueTodayJobs = 0, currentlyDueJobs = 0;
          
          const today = moment().format('YYYY-MM-DD');
          const currentlyDueOrders = [],
                dueTodayOrders = [], 
                // dueTomorrowOrders = [], 
                dueNextBusinessDayOrders = [],
                reprintOverdueOrders = [], 
                overdueOrders = [], 
                reprintOrders = [], 
                normalOrders = [], 
                RTSOrders = [],
                addressInvalidOrders = [],
                pendingPrintOrders = [],
                prePressOrders = [];
          let serviceTypeSelect = {},
              dueDateSelect = {},
              deliveryDateSelect = {},
              daysUntilDueSelect = {},
              ordersCommentMap = {};
          this.nextBusinessDate = nextBusinessDay;
          // console.log("this.nbd : ",this.nextBusinessDate)
          if(typeof this.nextBusinessDate === 'string') {
            const diffNBDAndToday = moment((nextBusinessDay)).diff(moment(today), 'days', true);
            // console.log("diffNBDAndToday: ", diffNBDAndToday > 0)
            this.store.dispatch({
              type: GET_LAST_EOD_RAN_TODAY,
              payload: { lastEODRanToday :  diffNBDAndToday}
            });
          }
          orders && orders.forEach(order => {
            if (order.status !== CANCELLED && order.status !== EOD_COMPLETED) {
              const shipment = shipments.find(shipment => shipment.orderId === order.id);
              const daysUntilDue = Math.ceil(moment(order.shipment.production_due_date).diff(moment(), 'days', true));
              const diffNBD = moment((nextBusinessDay || today)).diff(moment(order.shipment.production_due_date), 'days', true);
              const hasComment = this.commentOrder(order.activity_history);
              if(hasComment) {
                ordersCommentMap[order.id] = hasComment;
              }
              const formattedOrder = Object.assign({}, order, {
                hasShippingLabel: !!(shipment && shipment.shipmentStatus === SHIPPED && (shipment.trackingNumberUPS || shipment.trackingNumberUSPS || shipment.trackingNumberFEDEX))
              });
              
              if (formattedOrder.hasShippingLabel) {
                RTSOrders.push(formattedOrder);
              } 
              
              if (!formattedOrder.hasShippingLabel && +daysUntilDue === 0 && diffNBD <= 0) {
                dueTodayOrders.push(formattedOrder);
                dueTodayJobs += formattedOrder.jobs.length;

                if (!lastEODRanToday) {
                  currentlyDueOrders.push(formattedOrder);
                  currentlyDueJobs += formattedOrder.jobs.length;
                }
              }

              if(formattedOrder.address.validated === false && (shipment && shipment.shipmentStatus != SHIPPED)) {
                addressInvalidOrders.push(formattedOrder);
              }
              // if (!formattedOrder.hasShippingLabel && +daysUntilDue === 1 && diffNBD <= 0) {
              //   dueTomorrowOrders.push(formattedOrder);

              //   if (lastEODRanToday) {
              //     currentlyDueJobs += formattedOrder.jobs.length;
              //   }
              // }

              if (!formattedOrder.hasShippingLabel && diffNBD === 0) {
                dueNextBusinessDayOrders.push(formattedOrder);

                if (lastEODRanToday) {
                  currentlyDueJobs += formattedOrder.jobs.length;
                }
              }

              if (!formattedOrder.hasShippingLabel && order.reprint && diffNBD > 0) {
                reprintOverdueOrders.push(formattedOrder);
                lateJobs += formattedOrder.jobs.length;

                if (lastEODRanToday) {
                  currentlyDueJobs += formattedOrder.jobs.length;
                }
              }

              if (!formattedOrder.hasShippingLabel && !order.reprint && diffNBD > 0) {
                overdueOrders.push(formattedOrder);
                lateJobs += formattedOrder.jobs.length;

                if (lastEODRanToday) {
                  currentlyDueJobs += formattedOrder.jobs.length;
                }
              }

              if (!formattedOrder.hasShippingLabel && order.reprint && diffNBD <= 0) {
                reprintOrders.push(formattedOrder);
              }

              if (!formattedOrder.hasShippingLabel && !order.reprint && diffNBD <= 0) {
                normalOrders.push(formattedOrder);
              }

              if(formattedOrder.shipment.shipping_method && serviceTypeSelect[formattedOrder.shipment.shipping_method]) {
                serviceTypeSelect[formattedOrder.shipment.shipping_method]++;
              } else {
                serviceTypeSelect[formattedOrder.shipment.shipping_method] = 1;
              }

              if(formattedOrder.dueDate && dueDateSelect[formattedOrder.dueDate]) {
                dueDateSelect[formattedOrder.dueDate]++;
              } else {
                dueDateSelect[formattedOrder.dueDate] = 1;
              }

              if(formattedOrder.shipment.estimated_delivery_date && deliveryDateSelect[formattedOrder.shipment.estimated_delivery_date]) {
                deliveryDateSelect[formattedOrder.shipment.estimated_delivery_date]++;
              } else {
                deliveryDateSelect[formattedOrder.shipment.estimated_delivery_date] = 1;
              }

              if((!formattedOrder.hasShippingLabel && diffNBD > 0) && formattedOrder.status !== 'shipping') {
                  if(formattedOrder.shipment.production_due_date && daysUntilDueSelect[formattedOrder.shipment.production_due_date] ) {
                    daysUntilDueSelect[formattedOrder.shipment.production_due_date]++;
                  } else {
                    daysUntilDueSelect[formattedOrder.shipment.production_due_date] = 1;
                  }
              } 

              if(formattedOrder.status === PENDING_PRINTING) {
                pendingPrintOrders.push(formattedOrder);
              }

              if(formattedOrder.status === PREPRESS) {
                prePressOrders.push(formattedOrder);
              }
            }
          });

          if(serviceTypeSelect['ups_03']) {
            if(serviceTypeSelect['flatrate_ups_03']) {
              serviceTypeSelect['ups_03'] += serviceTypeSelect['flatrate_ups_03'];
              delete serviceTypeSelect['flatrate_ups_03'];
            }
            if(serviceTypeSelect['freeshipping_ups_03']) {
              serviceTypeSelect['ups_03'] += serviceTypeSelect['freeshipping_ups_03'];
              delete serviceTypeSelect['freeshipping_ups_03'];
            }
          }
          if(serviceTypeSelect['usps_4']) {
            if(serviceTypeSelect['usps_1']) {
              serviceTypeSelect['usps_4'] += serviceTypeSelect['usps_1'];
              delete serviceTypeSelect['usps_1'];
            }
          }
          serviceTypeSelect = Object.keys(serviceTypeSelect).reduce((arr, key)=>{
            const subObj = { type: SERVICE, id: key, qty : serviceTypeSelect[key], name: this.translate.instant(key.toUpperCase())};
            return arr.concat(subObj)
          }, []).sort((a, b) => (a.name > b.name) ? 1 : -1);
          deliveryDateSelect = Object.keys(deliveryDateSelect).reduce((arr, key)=>{
            const subObj = { type: DELIVERYDATE, id: key, qty : deliveryDateSelect[key]};
            return arr.concat(subObj)
          }, []).sort((a, b) => (a.id > b.id) ? 1 : -1);
          dueDateSelect = Object.keys(dueDateSelect).reduce((arr, key)=>{
            const subObj = { type: DUEDATE, id: key, qty : dueDateSelect[key]};
            return arr.concat(subObj)
          }, []).sort((a, b) => (a.id > b.id) ? 1 : -1);
          daysUntilDueSelect = Object.keys(daysUntilDueSelect).reduce((arr, key)=>{
            const subObj = { type: DAYSUNTILDUE, id: key, qty : daysUntilDueSelect[key], name: this.daysUntilDue.transform(nextBusinessDay, key)['daysUntilDueMsg'] };
            return arr.concat(subObj)
          }, []).sort((a, b) => (a.name > b.name) ? 1 : -1);

          if (lastEODRanToday) {
            currentlyDueOrders.push(
              ...reprintOverdueOrders,
              ...overdueOrders,
              // ...dueTomorrowOrders
              ...dueNextBusinessDayOrders
            );
          }
          
          this.store.dispatch({
            type   : GET_FILTERED_ORDERS,
            payload: { 
              addressInvalidOrders,
              currentlyDueOrders,
              currentlyDueJobs,
              dueTodayOrders,
              // dueTomorrowOrders,
              dueNextBusinessDayOrders,
              reprintOverdueOrders,
              overdueOrders,
              reprintOrders,
              normalOrders,
              RTSOrders,
              pendingPrintOrders,
              prePressOrders,
              serviceTypeSelect,
              deliveryDateSelect,
              dueDateSelect,
              daysUntilDueSelect
            }
          });
          this.store.dispatch({
            type   : SET_COMMENT_ORDERS_MAP,
            payload: { ordersCommentMap }
          });
          this.store.dispatch({
            type: SET_MAIN_VIEW,
            payload: {
              dueTodayJobs,
              lateJobs
            }
          });
        }),

        Observable
        .combineLatest(
          this.RTSTotal,
          this.currentlyDueOrders, 
          this.reprintOverdueOrders,
          this.overdueOrders
        )
        .subscribe(([ rtsTotal, currentlyDueOrders, reprintOverdueOrders, overdueOrders ]) => {
          if((rtsTotal && rtsTotal.RTS) && (currentlyDueOrders && currentlyDueOrders.orders) && reprintOverdueOrders && overdueOrders) {
            this.progressPercent = rtsTotal.RTS.length / (
              rtsTotal.RTS.length + 
              currentlyDueOrders.orders.length  + 
              reprintOverdueOrders.length + 
              overdueOrders.length) * 100;
            this.progressPercent = this.progressPercent > 100 ? 100 : Math.round(this.progressPercent);
          }
        }),
    ];
  }

  ngOnDestroy(): void {
    !!this.initSubscriptions && this.initSubscriptions.forEach(subscription => !!subscription && subscription.unsubscribe());

    this.store.dispatch({ type: _CLEAR });
  }

  commentOrder (activityHistory) {
    let found = false;
    for(var i = 0; i < activityHistory.length; i++) {
        if (activityHistory[i] && activityHistory[i].activity == 'comment') {
            found = true;
            break;
        }
    }
    return found;
  }

  openProcessEODModal(): void {
    if(this.allowEod) {
      this.shipmentService.processEOD.next();
    }
  }

  queryListNoResults(event: Event): void {
    this.queryListNoMatch = !!event;
  }

  searchQuery(query: string): void {
    query = query.replace(/\D+/g, "");
    this.query = query;
    Observable
      .combineLatest(
        this.jobList, 
        this.orderList,
        this.shipmentList
      )
      .take(1)
      .subscribe(
        ([ jobs, orders, shipments ]) => {
          const order = orders.find(order => order.id === query);
          const job   = jobs.find(job => job.id === query);
          const shipment = shipments.find(shipment => (order && shipment.orderId === order.id) || (job && shipment.orderId === job.orderId));
          const oneNonShippingJob = shipment ? !!jobs.filter(job => (<any>shipment.jobs).includes(job.id)).find(job => job.status != "shipping") : true;

          if (order && oneNonShippingJob) {
            this.router.navigate(['rfid/dashboard/orders/all', order.id]);
          } else if ((job && oneNonShippingJob)) {
            this.router.navigate(['rfid/dashboard/jobs', job.status, job.id]);
          } else if ((shipment && !oneNonShippingJob) || (shipment && !order && !job)) {
            this.router.navigate(['rfid/dashboard/shipping/all', shipment.id]);
          } else {
            this.orderService.getArchivedOrder.next({ id: query, category: RFID });
          }
        },
        (error: Error) => console.log(error)
      );
  }

  setLang(lang: string, url: string): void {
    this.language = { lang, url };
    if(localStorage.getItem('language') && localStorage.getItem('language') != lang) {
      localStorage.setItem('language', lang);
      this.translate.use(lang);
      window.location.reload();
    }
  }

  switchDashboard(dashboard : string): void {
    this.store.dispatch({
      type   : SET_MAIN_VIEW,
      payload: { dashboardSwitch: true }
    });
    this.store.dispatch({ type: _CLEAR });
    if(dashboard == RFID){
      this.router.navigate(['/rfid/dashboard/orders/all']);
    }else if(dashboard == OA){
      this.router.navigate(['/oa/dashboard/orders/all']);
    }else {
      this.router.navigate(['/dashboard/orders/all']);
    }
    this.store.dispatch({
      type   : SET_MAIN_VIEW,
      payload: { dashboardSwitch: false }
    });
  }
}


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/layouts/rfid-layout.component.ts